module.exports = __webpack_public_path__ + "img/icon-question.eaac30c9.svg";